"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TabSwitchedEvent {
    constructor(_oldSheetName, _newSheetName) {
        this._oldSheetName = _oldSheetName;
        this._newSheetName = _newSheetName;
    }
    get oldSheetName() {
        return this._oldSheetName;
    }
    get newSheetName() {
        return this._newSheetName;
    }
}
exports.TabSwitchedEvent = TabSwitchedEvent;
//# sourceMappingURL=TabSwitchedEvent.js.map